import React from 'react';

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: React.ReactNode;
  error?: string;
  className?: string;
  labelClassName?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  label,
  error,
  className = '',
  labelClassName = '',
}) => {
  return (
    <div className={`custom-checkbox w-full mt-6 ${className}`}>
      <label className="flex items-start cursor-pointer select-none text-left w-full">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="hidden-checkbox hidden"
        />
        <span
          className={`checkbox-icon min-w-5 h-5 border-2 border-gray-800 rounded flex items-center justify-center transition-all duration-200 mr-2 relative mt-0.5 ${
            checked ? 'bg-gray-800' : 'bg-transparent'
          }`}
        >
          {checked && (
            <span
              className="w-3 h-1.5 border-l-2 border-b-2 border-white transform -rotate-45 opacity-100 absolute left-0.5 top-0.5"
              style={{
                borderLeft: '2px solid white',
                borderBottom: '2px solid white',
                transform: 'rotate(-45deg)',
              }}
            />
          )}
        </span>
        {label && (
          <span className={`checkbox-label text-sm text-gray-500 lg:text-sm flex-1 ${labelClassName}`}>
            {label}
          </span>
        )}
      </label>
      {error && (
        <p className="text-sm text-red-500 mt-2 text-left">{error}</p>
      )}
    </div>
  );
};

export default Checkbox;